module.exports = __webpack_public_path__ + "static/media/10420327_881377548553136_8047997091709308725_n.8b9f9176.jpg";